// extracted by mini-css-extract-plugin
export var avatar = "team-module--avatar--mrceR";
export var body = "team-module--body--vnaM0";
export var circle = "team-module--circle--klDh9";
export var component = "team-module--component--sAl-t";
export var info = "team-module--info--sl1s8";
export var member = "team-module--member--X6sQs";
export var members = "team-module--members--63PK2";
export var name = "team-module--name--UK8Ki";
export var position = "team-module--position--VbCPu";